/// <reference types="vite/client" />
import type { ReactNode } from 'react';
import {
  Outlet,
  createRootRouteWithContext,
  HeadContent,
  Scripts,
} from '@tanstack/react-router';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { ArrowRight } from 'lucide-react';
import { Toaster } from 'react-hot-toast';
import { ButtonLink } from '../components/Button';
import Logo from '../components/Logo';
import type { RouterContext } from '../router';
import appCss from '../index.css?url';

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [
      { charSet: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { title: 'Donar MVP' },
    ],
    links: [
      { rel: 'icon', type: 'image/png', href: '/favicon@2x.png' },
      { rel: 'stylesheet', href: appCss },
    ],
  }),
  component: RootComponent,
  notFoundComponent: NotFound,
});

function NotFound() {
  return (
    <div className="theme-donar min-h-screen flex flex-col items-center justify-center px-4 text-center">
      <Logo className="h-28 w-auto" />
      <h1 className="mt-8 text-2xl font-extrabold uppercase md:text-3xl">
        404 - Basket niet gevonden
      </h1>
      <p className="mt-4 mb-8">We konden niet vinden waar je naar zocht.</p>
      <ButtonLink to="/">
        Terug naar home
        <ArrowRight className="h-5 w-5" />
      </ButtonLink>
    </div>
  );
}

function RootComponent() {
  return (
    <RootDocument>
      <Outlet />
      <Toaster position="bottom-center" />
      {import.meta.env.DEV && (
        <TanStackDevtools
          config={{ position: 'bottom-right' }}
          plugins={[
            {
              id: 'router',
              name: 'TanStack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
            {
              id: 'query',
              name: 'React Query',
              render: <ReactQueryDevtoolsPanel />,
            },
          ]}
        />
      )}
    </RootDocument>
  );
}

function RootDocument({ children }: Readonly<{ children: ReactNode }>) {
  return (
    <html lang="nl">
      <head>
        <HeadContent />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  );
}
